// src/hooks/useWalletId.js
import { useMemo, useEffect } from "react";
import { useAuth } from "../auth/AuthProvider";
import { useSettings } from "../settings";

function toPosInt(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return null;
  const id = Math.trunc(n);
  return id > 0 ? id : null;
}

export function useWalletId() {
  const { auth } = useAuth();
  const { settings, setSelectedWalletIdIfEmpty } = useSettings();

  const selected = toPosInt(settings?.selectedWalletId);
  const fallback = toPosInt(auth?.defaultWalletId);

  const walletId = useMemo(() => {
    return selected || fallback || null;
  }, [selected, fallback]);

  // ✅ se está logado e ainda não tem selectedWalletId, trava o default no settings
  useEffect(() => {
    if (!selected && fallback) {
      setSelectedWalletIdIfEmpty?.(fallback);
    }
  }, [selected, fallback, setSelectedWalletIdIfEmpty]);

  return walletId;
}
